export default __webpack_public_path__ + "static/media/credibilityIllustrator.bb64d6c0.svg";